import { render, staticRenderFns } from "./detail_company_prosp_sp.vue?vue&type=template&id=130ba426&scoped=true&"
import script from "./detail_company_prosp_sp.vue?vue&type=script&lang=js&"
export * from "./detail_company_prosp_sp.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./detail_company_prosp_sp.vue?vue&type=style&index=1&id=130ba426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130ba426",
  null
  
)

export default component.exports